import { Button, Empty, EmptyContent, EmptyDescription, EmptyHeader } from '@monksflow/monks-ui';
import { PlusIcon } from 'lucide-react';
import { EmptyStateTitle } from '@/shared/ui';
import { useTranslation } from 'react-i18next';

interface EmailTemplatesEmptyStateProps {
  onCreate: () => void;
}

/** Zero templates and no active search. The no-results variant is a separate component. */
export function EmailTemplatesEmptyState({ onCreate }: EmailTemplatesEmptyStateProps) {
  const { t } = useTranslation('knowledge');

  return (
    <Empty role="status" data-testid="email-templates-empty-state" className="flex-1">
      <EmptyHeader>
        <EmptyStateTitle>{t('knowledgeHub.emailTemplatesList.emailTemplates')}</EmptyStateTitle>
        <EmptyDescription>{t('knowledgeHub.emailTemplatesList.description')}</EmptyDescription>
      </EmptyHeader>
      <EmptyContent>
        <Button variant="default" size="default" onClick={onCreate}>
          <PlusIcon className="size-4" />
          {t('knowledgeHub.emailTemplatesToolbar.newEmailTemplate')}
        </Button>
      </EmptyContent>
    </Empty>
  );
}
